// extracted by mini-css-extract-plugin
export var back = "styles-module--back--e5c16";